import StepsTemplate from "./steps-template";

export default StepsTemplate;
